module.exports = __webpack_public_path__ + "img/collaboration.9ecb801a.svg";